import type { ZodError, ZodIssue, ZodType } from "zod";

/**
 * Thrown when seed content fails its runtime schema. Unlike the save layer
 * (fail-safe), content is authored by the team, so loading is fail-fast.
 */
export class ContentValidationError extends Error {
  readonly issues: ReadonlyArray<ZodIssue>;

  constructor(error: ZodError) {
    const summary = error.issues
      .map((issue) => `${issue.path.join(".") || "(root)"}: ${issue.message}`)
      .join("; ");
    super(`content validation failed: ${summary}`);
    this.name = "ContentValidationError";
    this.issues = error.issues;
  }
}

export function loadContent<T>(raw: unknown, schema: ZodType<T>): T {
  const result = schema.safeParse(raw);
  if (!result.success) {
    throw new ContentValidationError(result.error);
  }
  return result.data;
}
